import React, { Component } from "react";
import MyProvider from "./contexts/MyProvider";
import "./custom.css";
import "./styles/main.scss";
import { AdminSwitch } from "./infrastructure/AdminSwitch";
import { DefaultSwitch } from "./infrastructure/DefaultSwitch";
import { CustomerServiceSwitch } from "./infrastructure/CustomerServiceSwitch";
import { TicketRefundSwitch } from "./infrastructure/TicketRefundSwitch";
import { ContactServiceSwitch } from "./infrastructure/ContactServiceSwitch";
import { SurchargeSwitch } from "./infrastructure/SurchargeSwitch";

export default class App extends Component {
  static displayName = App.name;

  constructor(props) {
    super(props);
    this.state = {
      mode: "",
      firstLoad: true,
      allowFileUploadExtension: [],
      totalCostSEKMax: "",
    };
  }

  render() {
    this.state.mode = window.__RUNTIME_CONFIG__.Mode;

    if (this.state.mode != "") {
      switch (this.state.mode) {
        case "admin":
          return (
            <MyProvider {...this.state}>
              <AdminSwitch />
            </MyProvider>
          );
        case "portal":
        case "public":
          return (
            <MyProvider {...this.state}>
              <DefaultSwitch />
            </MyProvider>
          );
        case "customer-service":
          return (
            <MyProvider {...this.state}>
              <CustomerServiceSwitch />
            </MyProvider>
          );
        case "contact-service":
          return (
            <MyProvider {...this.state}>
              <ContactServiceSwitch />
            </MyProvider>
          );
        case "ticket-refund":
          return (
            <MyProvider {...this.state}>
              <TicketRefundSwitch />
            </MyProvider>
          );
        case "surcharge":
          return (
            <MyProvider {...this.state}>
              <SurchargeSwitch />
            </MyProvider>
          );
        default:
          break;
      }
    }
    return "";
  }
}
